import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { useIsOrganizationAdmin } from '../../../../../../hooks/api/useOrganization';
import useOrganizationCareTeamMembers from '../../../../../../hooks/api/useOrganizationCareTeamMembers';
import { getIntl } from '../../../../../../utils/intl';
import { SideDrawerButtonContainer } from '../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import OrganizationCareTeamMemberDetails from '../../../../../shared/OrganizationCareTeamMember/OrganizationCareTeamMemberDetails';

const intl = getIntl('organization-care-team-side-drawer-content', {
    delete: 'Delete',
    edit: 'Edit',
});

export type CareTeamMemberDetailsSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
    careTeamMemberId: string;
    onEdit: () => void;
};

export type CareTeamMemberDetailsSideDrawerContentProps = CareTeamMemberDetailsSideDrawerContentOwnProps;

const CareTeamMemberDetailsSideDrawerContent: React.FC<CareTeamMemberDetailsSideDrawerContentProps> = ({
    onClose,
    careTeamMemberId,
    onEdit,
}) => {
    const { organizationCareTeamMember, isLoadingOrganizationCareTeamMember, deleteCareTeamMember } =
        useOrganizationCareTeamMembers({
            organizationCareTeamMemberId: careTeamMemberId,
            onDeleteCareTeamMember: () => onClose(true),
        });
    const isAdmin = useIsOrganizationAdmin();

    return (
        <AnimateLoadedContent isLoading={isLoadingOrganizationCareTeamMember || !organizationCareTeamMember}>
            {() => (
                <SideDrawerButtonContainer
                    buttons={[
                        {
                            title: intl('edit'),
                            onPress: onEdit,
                            testID: 'edit-care-team-member-button',
                            icon: 'Edit2',
                            variant: 'primary',
                        },
                        {
                            title: intl('delete'),
                            onPress: () => {
                                deleteCareTeamMember(careTeamMemberId);
                                onClose(false);
                            },
                            isDisabled: !isAdmin,
                            testID: 'delete-care-team-member-button',
                            icon: 'Trash2',
                            variant: 'alert',
                        },
                    ]}
                >
                    <OrganizationCareTeamMemberDetails
                        organizationCareTeamMemberId={careTeamMemberId}
                        organizationCareTeamMember={organizationCareTeamMember!}
                    />
                </SideDrawerButtonContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(CareTeamMemberDetailsSideDrawerContent);
